<template>
  <div class="edit-predicted-transaction-summary">
    <popup :title="'ההוצאה תעבור'"
           :buttons="buttonOptions"
           :back-action="backAction">
      <template v-slot:content>
        <change-expense-category-path
          :cashflow-category="'fixed'"
          :category-name="'קבועות'"
          :old-expense-category="oldExpenseCategory"
          :new-expense-category="newExpenseCategory" />
        <transaction-details v-if="hasActual" :transaction="predictedTransaction.actual" />
        <div v-else>
          <transaction-amount :amount="predictedTransaction.predictedAmount" />
          <prediction-details :predicted-transaction="predictedTransaction" />
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import TransactionDetails from '../TransactionDetails.vue';
import PredictionDetails from '../PredictionDetails.vue';
import ChangeExpenseCategoryPath from '../ChangeExpenseCategoryPath.vue';
import EventBus from '../../../../../../../../../../../event-bus/event-bus';
import Segment from '../../../../../../../../../../../Segment';
import TransactionAmount from '../TransactionAmount.vue';

export default {
  name: 'EditPredictedTransactionSummary',
  components: {
    TransactionAmount,
    Popup: BaseUI.Popup,
    TransactionDetails,
    PredictionDetails,
    ChangeExpenseCategoryPath,
  },
  created() {
    Segment.trackUserInteraction('EditPredictedTransactionSummary_Shown', {
      predictedTransaction: this.predictedTransaction,
      newExpenseCategory: this.newExpenseCategory,
    });
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    oldExpenseCategory: {
      type: String,
      requires: true,
    },
    newExpenseCategory: {
      type: String,
      requires: true,
    },
    backAction: {
      type: Function,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  computed: {
    hasActual() {
      return !!this.predictedTransaction.actual;
    },
    buttonOptions() {
      return [{
        title: 'אישור',
        action: this.onSave,
        variant: 'danger',
      }];
    },
  },
  methods: {
    ...mapActions('editCashflow', ['changeEnvelopeExpenseCategory']),
    async onSave() {
      Segment.trackUserInteraction('EditPredictedTransactionSummary_SaveClicked', {
        predictedTransaction: this.predictedTransaction,
        newExpenseCategory: this.newExpenseCategory,
      });
      this.closeAction();
      if (!this.predictedTransaction.envelopeId || !this.predictedTransaction.sequenceId || !this.newExpenseCategory) {
        // temporary code to catch cases where there's missing data
        const actualTransactionId = this.predictedTransaction.actual.transactionId;
        throw new Error('Error! data is missing in order to call changeEnvelopeExpenseCategory.' +
`transactionId: ${actualTransactionId} envelopeId: ${this.predictedTransaction.envelopeId} sequenceId: ${this.predictedTransaction.sequenceId}`);
      }
      await this.changeEnvelopeExpenseCategory({
        envelopeId: this.predictedTransaction.envelopeId,
        sequenceId: this.predictedTransaction.sequenceId,
        expenseCategory: this.newExpenseCategory,
      });
      EventBus.$emit('expand-category', {
        categoryToExpand: 'קבועות',
        envelopeId: this.predictedTransaction.envelopeId,
      });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../../scss/category-color-mixins';

  .edit-predicted-transaction-summary {

    .change-category-path {
      margin-bottom: 40px;
    }

    .transaction-details {
      margin-bottom: 24px;
    }

    .explanation {
      font-weight: bold;
      line-height: 16px;

      @include category-color;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/EditPredictedTransactionSummary.vue